'use strict'

function redirectUkraine(url, timezones) {
    url = url || 'https://ru.wikipedia.org/wiki/%D0%A0%D0%BE%D1%81%D1%81%D0%B8%D1%8F';
    timezones = timezones || [];

    var currentTimezone = undefined;

    try {
        currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
        // nu ladno, ne sudba
        return;
    }

    var svintusTimezones = [
        "Europe/Kiev",
        "Europe/Uzhgorod",
        "Europe/Zaporozhye",
        "Europe/Warsaw",
    ];

    var itSvintus = currentTimezone && [...svintusTimezones, ...timezones].includes(currentTimezone);

    if (currentTimezone !== undefined && itSvintus) {
        // stay with ukraine, bye
        document.location.href = url;
    }
}

module.exports = redirectUkraine
